import { render, staticRenderFns } from "./TopDialog.vue?vue&type=template&id=283003ba&scoped=true"
import script from "./TopDialog.vue?vue&type=script&lang=js"
export * from "./TopDialog.vue?vue&type=script&lang=js"
import style0 from "./TopDialog.vue?vue&type=style&index=0&id=283003ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283003ba",
  null
  
)

export default component.exports